@if (showAnimatedDigit) {
    @for (digit of digits; track $index) {
        <span class="live-scores-digit" [ngClass]="'digit-' + digit" data-crlat="scoreDigit" [textContent]="digit"> </span>
    }
} @else {
    <span data-crlat="scoreDigit" [textContent]="number"></span>
}
